var url = "a00ebbb7b1cf1fc4ac75a7fd99e95c0c.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;